<template>
  <div class="pending" v-if="pending">
    <v-progress-circular :size="70" :width="7" color="primary" indeterminate>
    </v-progress-circular>
  </div>
  <v-container fluid v-else class="align-self-start">
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn @click="newDeployment">{{ $t('add_deployment') }}</v-btn>
      </v-col>
    </v-row>
    <v-row align="stretch">
      <v-col v-for="item in items" cols="3">
        <router-link class="router" :to="{ name: 'Deployment', params: { id: item.id } }">
          <v-card class="deployment v-btn v-btn--flat" height="100%">
            <v-card-title>
              {{ item.id }}
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col align-self="start">
                  <p>{{ $t('subscription', { status: item.status }) }}</p>
                  <div v-if="item.creationDate">
                    <p>{{ $t('created', { date: item.creationDateStr }) }}</p>
                  </div>
                  <div v-if="item.renewalDate">
                    <p>{{ $t('renews', { date: item.renewalDateStr }) }}</p>
                  </div>
                  <p v-if="item.deviceLimit">
                    {{ $t('devices_monitored_limit', { count: item.deviceCount, limit: item.deviceLimit }) }}
                  </p>
                  <p v-else-if="item.deviceCount !== 0">
                    {{ $t('devices_monitored', { count: item.deviceCount }) }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
    <u-new-deployment :open="wizardIsOpen" @close="closeWizard" :deployments="items" />
  </v-container>
</template>

<script>
import { fetchDeployments } from '@/services/deployments'
import NewDeploymentComponent from '@/components/NewDeployment.vue'

const dateFormatter = new Intl.DateTimeFormat(process.env.VUE_APP_I18N_LOCALE)

export default {
  data() {
    return {
      items: [],
      now: new Date(),
      pending: true,
      snackbar: false,
      snackBarMessage: '',
      snackBarTimeout: 3000,
      snackBarClose: this.$t('snackbar.close'),
      wizardIsOpen: false
    }
  },
  mounted() {
    this.fetch().then(() => {
      this.pending = false
    })
  },
  methods: {
    async fetch() {
      const deployments = await fetchDeployments()

      this.items = deployments.map(deployment => {
        if (deployment.renewalDate) {
          deployment.renewalDateStr = dateFormatter.format(deployment.renewalDate = new Date(deployment.renewalDate))
        }

        if (deployment.creationDate) {
          deployment.creationDateStr = dateFormatter.format(new Date(deployment.creationDate))
        }

        if (deployment.renewalDate && this.now > deployment.renewalDate) {
          deployment.status = this.$t('expired')
        } else {
          if (deployment.creationDate) {
            deployment.status = this.$t('active')
          } else {
            deployment.status = this.$t('trial')
          }
        }

        deployment.deviceCount = deployment.deviceCount || 0
        deployment.deviceLimit = deployment.deviceLimit || 0

        return deployment
      })
    },
    newDeployment() {
      this.wizardIsOpen = true
    },
    closeWizard() {
      this.wizardIsOpen = false
      this.fetch()
    }
  },
  components: {
    'u-new-deployment': NewDeploymentComponent
  }
}
</script>

<style lang="scss" scoped>
.pending {
  margin: auto;
}

.deployment {
  text-transform: none;
}

.router {
  text-decoration: none;
}
</style>

<i18n>
{
  "en": {
    "active": "Active",
    "add_deployment": "Add Deployment",
    "created": "Created: {date}",
    "devices_monitored": "{count} devices monitored",
    "devices_monitored_limit": "{count} / {limit} devices monitored",
    "expired": "Expired",
    "renews": "Renews: {date}",
    "subscription": "Subscription: {status}",
    "trial": "Trial"
  }
}
</i18n>
